<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/6chap1#chap1">Return … a preface by K. Leslie Steiner</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/8chap2#chap2">The Tale of Gorgik</a></p>
<p class="toc2"><a href="#/Book1/OPS/9chap3#chap3">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/10chap4#chap4">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/11chap5#chap5">3</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/12chap6#chap6">The Tale of Old Venn</a></p>
<p class="toc2"><a href="#/Book1/OPS/13chap7#chap7">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/14chap8#chap8">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/15chap9#chap9">3</a></p>
<p class="toc2"><a href="#/Book1/OPS/16chap10#chap10">4</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/17chap11#chap11">The Tale of Small Sarg</a></p>
<p class="toc2"><a href="#/Book1/OPS/18chap12#chap12">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/19chap13#chap13">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/20chap14#chap14">3</a></p>
<p class="toc2"><a href="#/Book1/OPS/21chap15#chap15">4</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/22chap16#chap16">The Tale of Potters and Dragons</a></p>
<p class="toc2"><a href="#/Book1/OPS/23chap17#chap17">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/24chap18#chap18">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/25chap19#chap19">3</a></p>
<p class="toc2"><a href="#/Book1/OPS/26chap20#chap20">4</a></p>
<p class="toc2"><a href="#/Book1/OPS/27chap21#chap21">5</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/28chap22#chap22">The Tale of Dragons and Dreamers</a></p>
<p class="toc2"><a href="#/Book1/OPS/29chap23#chap23">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/30chap24#chap24">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/31chap25#chap25">3</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/OPS/32chap26#chap26">Appendix: Some Informal Remarks Towards the Modular Calculus, Part Three by S. L. Kermit</a></p>
<p class="toc2"><a href="#/Book1/OPS/33chap27#chap27">1</a></p>
<p class="toc2"><a href="#/Book1/OPS/34chap28#chap28">2</a></p>
<p class="toc2"><a href="#/Book1/OPS/35chap29#chap29">3</a></p>
<p class="toc2"><a href="#/Book1/OPS/36chap30#chap30">4</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-TOC.vue?0cf17ba8